/*import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { TextField, Button } from '@mui/material';
import { PAPER_TABS, PAPER_CONFIG } from '../../data/common';
import { vocabularyApi } from '../../api/global';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import ArrowIc from '../../assets/images/ic_arrow_line.svg';
import ToggleSwitch from '../../components/common/ToggleSwitch';

const radioStyle = {
  color: '#000',
  '&.Mui-checked': {
    color: '#000',
  },
};

const INSTITUTE = {
  NAME: '캠퍼스명',
  LOGO: '캠퍼스로고',
};

function PrintSet({
  open,
  config,
  setConfig,
  paperTab,
  setTab,
  setPrintSetTrigger,
  loadedPaperData = undefined,
  isExchange = undefined,
}) {
  const [filter, setFilter] = useState(INSTITUTE.NAME);
  const [openedFilters, setOpenedFilters] = useState([]);
  const [toggleVocaFirstWordShow, setToggleVocaFirstWordShow] = useState(false);
  const [toggleExamKorShow, setToggleExamKorShow] = useState(false);
  const [logoMouseOver, setLogoMouseOver] = useState(false);
  const fileRef = useRef(null);

  // 저장한 시험지 로드시 config 세팅
  useEffect(() => {
    if (loadedPaperData === undefined) return;
    setConfig(prev => {
      return {
        ...prev,
        orgName: loadedPaperData.academy_name,
        orgLogoUrl: loadedPaperData.logoUrl,
        className: loadedPaperData.class_name,
        teacherName: loadedPaperData.teacher_name,
        paperName: loadedPaperData.exam_name,
      };
    });
  }, [loadedPaperData, setConfig]);

  const handleLogofile = async e => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file !== undefined) {
      try {
        const fd = new FormData();
        fd.append('image', file);
        const { data } = await vocabularyApi.saveLogo(fd);
        setConfig(prev => ({
          ...prev,
          orgLogoFile: file,
          orgLogoUrl: data.url,
        }));
      } catch (error) {
        console.error(error);
      } finally {
        e.target.value = null;
      }
    }
  };

  useEffect(() => {
    if (isExchange) {
      setToggleVocaFirstWordShow(false);
      setToggleExamKorShow(false);
    }
  }, [isExchange]);

  // 토글버튼 이벤트 config에 저장
  useEffect(() => {
    setConfig(prev => ({
      ...prev,
      vocaFirstWordShow: toggleVocaFirstWordShow,
      examKorShow: toggleExamKorShow,
    }));
  }, [toggleVocaFirstWordShow, toggleExamKorShow, setConfig]);

  return (
    <div
      className="absolute top-[0] right-[0] flex justify-between transition-all items-center h-full bg-[#969ba4]"
      style={{ right: open.set || open.print ? 0 : '-600px' }}
    >
      <div className="flex flex-col items-center justify-start h-full w-[440px]">
        <div className="grow overflow-auto w-full bg-[white] py-[30px] px-[24px]">
          <div className="text-[18px] font-[700] mb-[24px]">시험지 설정</div>
          <div className="text-[14px] font-[700] mb-[8px]">캠퍼스표기</div>
          <div className="mb-[12px]">
            <Select
              value={filter}
              fullWidth
              onChange={e => {
                if (e.target.value === INSTITUTE.LOGO) {
                  setConfig(prev => ({ ...prev, logoAppearYN: true }));
                } else {
                  setConfig(prev => ({ ...prev, logoAppearYN: false }));
                }
                setFilter(e.target.value);
                setPrintSetTrigger(prev => !prev);
              }}
              onOpen={() => setOpenedFilters([...openedFilters, '구분'])}
              onClose={() =>
                setOpenedFilters(openedFilters.filter(f => f !== '구분'))
              }
              displayEmpty
              size="small"
              IconComponent={() => (
                <img
                  src={ArrowIc}
                  alt="ArrowIc"
                  style={{
                    transform: openedFilters.includes('구분')
                      ? 'rotate(180deg)'
                      : 'rotate(0deg)',
                  }}
                />
              )}
              sx={{ background: '#fff' }}
            >
              <MenuItem
                value={INSTITUTE.NAME}
                sx={{ fontFamily: 'Pretendard' }}
              >
                캠퍼스명
              </MenuItem>
              <MenuItem
                value={INSTITUTE.LOGO}
                sx={{ fontFamily: 'Pretendard' }}
              >
                캠퍼스로고
              </MenuItem>
            </Select>
          </div>
          <div className="w-full">
            {filter === INSTITUTE.NAME ? (
              <div className="w-full mb-[12px]">
                <div className="mb-[8px]">캠퍼스명</div>
                <TextField
                  value={config.orgName}
                  onChange={e => {
                    if (e.target.value?.length > 12) return;
                    setConfig({
                      ...config,
                      orgName: e.target.value,
                    });
                  }}
                  fullWidth
                  size="small"
                  placeholder="캠퍼스명을 입력해 주세요(최대 12자)"
                  onBlur={() => setPrintSetTrigger(prev => !prev)}
                  InputProps={{
                    style: { fontFamily: 'Pretendard' },
                  }}
                />
              </div>
            ) : (
              <div className="w-full">
                <div className="mb-[12px]">캠퍼스로고</div>
                <div className="flex justify-between items-center gap-2 mb-[8px] overflow-hidden text-ellipsis">
                  <div className="grow flex justify-between h-[38px] items-center gap-2 overflow-hidden text-ellipsis border border-[#E2E8EF]">
                    <div
                      className="flex items-center justify-start px-[14px] leading-[17px] text-[#A9B6CA]"
                      style={{
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        wordBreak: 'break-word',
                      }}
                    >
                      {config?.orgLogoFile === null
                        ? '캠퍼스로고를 업로드 해 주세요'
                        : config?.orgLogoFile?.name}
                    </div>
                  </div>
                  <input
                    ref={fileRef}
                    onChange={handleLogofile}
                    type="file"
                    style={{ display: 'none' }}
                  />
                  <Button
                    variant="gray"
                    sx={{
                      flexShrink: 0,
                      px: '20px',
                      color: '#383C4B',
                      fontWeight: 700,
                    }}
                    onClick={() => fileRef.current.click()}
                  >
                    업로드
                  </Button>
                </div>
                <div
                  className="flex justify-center items-center text-[#383C4B] font-[700] w-full h-[130px] border mb-[12px] bg-[#fafafa]"
                  style={{
                    backgroundImage: `url(${config.orgLogoUrl})`,
                    backgroundSize: 'contain',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                  }}
                  onMouseEnter={
                    config?.orgLogoUrl !== null
                      ? () => setLogoMouseOver(true)
                      : null
                  }
                  onMouseLeave={
                    config?.orgLogoUrl !== null
                      ? () => setLogoMouseOver(false)
                      : null
                  }
                >
                  {config?.orgLogoUrl === null && '미리보기'}
                  {config?.orgLogoUrl !== null && logoMouseOver && (
                    <button
                      type="button"
                      className="w-[58px] h-[24px] text-[12px] rounded-[2px] flex justify-center items-center bg-[#E2E8EF]"
                      onClick={() => {
                        setConfig({
                          ...config,
                          orgLogoFile: null,
                          orgLogoUrl: null,
                        });
                      }}
                    >
                      삭제하기
                    </button>
                  )}
                </div>
              </div>
            )}
          </div>
          <div className="w-full mb-[12px]">
            <div className="mb-[8px]">클래스명</div>
            <TextField
              value={config.className}
              onChange={e => {
                if (e.target.value?.length > 8) return;
                setConfig({
                  ...config,
                  className: e.target.value,
                });
              }}
              fullWidth
              size="small"
              maxLength={10}
              placeholder="클래스명을 입력해 주세요(최대 8자)"
              onBlur={() => setPrintSetTrigger(prev => !prev)}
              InputProps={{
                style: { fontFamily: 'Pretendard' },
              }}
            />
          </div>
          <div className="w-full mb-[12px]">
            <div className="mb-[8px]">선생님(인쇄용)</div>
            <TextField
              value={config.teacherName}
              onChange={e => {
                if (e.target.value?.length > 7) return;
                setConfig({
                  ...config,
                  teacherName: e.target.value,
                });
              }}
              fullWidth
              size="small"
              placeholder="성함을 입력해주세요(최대7자)"
              onBlur={() => setPrintSetTrigger(prev => !prev)}
              InputProps={{
                style: { fontFamily: 'Pretendard' },
              }}
            />
          </div>
          <div className="w-full mb-[12px]">
            <div className="mb-[8px]">시험지명</div>
            <TextField
              value={config.paperName}
              onChange={e => {
                if (e.target.value?.length > 30) return;
                setConfig({
                  ...config,
                  paperName: e.target.value,
                });
              }}
              fullWidth
              size="small"
              placeholder="시험지명을 입력해주세요(최대30자)"
              onBlur={() => setPrintSetTrigger(prev => !prev)}
              InputProps={{
                style: { fontFamily: 'Pretendard' },
              }}
            />
          </div>
          <hr className="my-[12px] border border-[#A9B6CA]" />
          <div className="text-[14px] font-[700] mb-[8px]">단설정</div>
          <FormControl>
            <RadioGroup
              row
              defaultValue={2}
              onChange={e =>
                setConfig({ ...config, paperDiv: Number(e.target.value) })
              }
            >
              <FormControlLabel
                value={2}
                control={<Radio sx={radioStyle} />}
                label="2단"
              />
              <FormControlLabel
                value={1}
                control={<Radio sx={radioStyle} />}
                label="1단"
              />
            </RadioGroup>
          </FormControl>
          <hr className="my-[12px] border border-[#A9B6CA]" />
          <div className="text-[14px] font-[700] mb-[8px]">글자크기</div>
          <FormControl>
            <RadioGroup
              row
              defaultValue={PAPER_CONFIG.FONT_SIZE.NORMAL}
              onChange={e =>
                setConfig({ ...config, fontSize: Number(e.target.value) })
              }
            >
              <FormControlLabel
                value={PAPER_CONFIG.FONT_SIZE.NORMAL}
                control={<Radio sx={radioStyle} />}
                label="보통"
              />
              <FormControlLabel
                value={PAPER_CONFIG.FONT_SIZE.SMALL}
                control={<Radio sx={radioStyle} />}
                label="최소"
              />
              <FormControlLabel
                value={PAPER_CONFIG.FONT_SIZE.LARGE}
                control={<Radio sx={radioStyle} />}
                label="최대"
              />
            </RadioGroup>
          </FormControl>
          <hr className="my-[12px] border border-[#A9B6CA]" />
          <div className="text-[14px] font-[700] mb-[8px]">줄간격</div>
          <FormControl>
            <RadioGroup
              row
              defaultValue={PAPER_CONFIG.LINE_SPACING.NORMAL}
              onChange={e =>
                setConfig({ ...config, spacing: Number(e.target.value) })
              }
            >
              <FormControlLabel
                value={PAPER_CONFIG.LINE_SPACING.NORMAL}
                control={<Radio sx={radioStyle} />}
                label="보통"
              />
              <FormControlLabel
                value={PAPER_CONFIG.LINE_SPACING.SMALL}
                control={<Radio sx={radioStyle} />}
                label="좁게"
              />
              <FormControlLabel
                value={PAPER_CONFIG.LINE_SPACING.LARGE}
                control={<Radio sx={radioStyle} />}
                label="넓게"
              />
            </RadioGroup>
          </FormControl>
          <hr className="my-[12px] border border-[#A9B6CA]" />
          <div className="text-[14px] font-[700] mb-[8px]">보기 설정</div>
          <FormControl>
            <RadioGroup
              defaultValue={PAPER_TABS.TEST_PAPER}
              value={paperTab}
              onChange={e => {
                setTab(e.target.value);
                setConfig({ ...config, viewMode: e.target.value });
              }}
            >
              <FormControlLabel
                value={PAPER_TABS.TEST_PAPER}
                control={<Radio sx={radioStyle} />}
                label="시험지 보기"
              />
              <FormControlLabel
                value={PAPER_TABS.ANSWER}
                control={<Radio sx={radioStyle} />}
                label="정답만 보기"
              />
              <FormControlLabel
                value={PAPER_TABS.ANSWER_TEST_PAPER}
                control={<Radio sx={radioStyle} />}
                label="정답이 표시된 시험지 보기"
              />
              <FormControlLabel
                value={PAPER_TABS.VOCABULARY_LIST}
                control={<Radio sx={radioStyle} />}
                label="어휘 리스트 보기"
              />
            </RadioGroup>
          </FormControl>
          <hr className="my-[12px] border border-[#A9B6CA]" />
          <div className="flex justify-between items-center h-[36px]">
            <div className="text-[14px] font-[700]">영단어 첫글자 보여주기</div>
            <ToggleSwitch
              toggle={toggleVocaFirstWordShow}
              setToggle={setToggleVocaFirstWordShow}
            />
          </div>
          <hr className="my-[12px] border border-[#A9B6CA]" />
          <div className="flex justify-between items-center h-[36px]">
            <div className="text-[14px] font-[700]">예문 해석 보여주기</div>
            <ToggleSwitch
              toggle={toggleExamKorShow}
              setToggle={setToggleExamKorShow}
            />
          </div>
          <hr className="my-[12px] border border-[#A9B6CA]" />
        </div>
      </div>
    </div>
  );
}

PrintSet.propTypes = {
  open: PropTypes.object.isRequired,
  config: PropTypes.object.isRequired,
  setConfig: PropTypes.func.isRequired,
  paperTab: PropTypes.string.isRequired,
  setTab: PropTypes.func.isRequired,
  generatedPaper: PropTypes.array,
  setPrintSetTrigger: PropTypes.func.isRequired,
  loadedPaperData: PropTypes.object,
  isExchange: PropTypes.bool,
};

export default React.memo(PrintSet);
*/
import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { TextField, Button } from '@mui/material';
import { PAPER_TABS, PAPER_CONFIG } from '../../data/common';
import { vocabularyApi } from '../../api/global';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import ArrowIc from '../../assets/images/ic_arrow_line.svg';
import ToggleSwitch from '../../components/common/ToggleSwitch';

const radioStyle = {
  color: '#000',
  '&.Mui-checked': {
    color: '#000',
  },
};

const INSTITUTE = {
  NAME: '캠퍼스명',
  LOGO: '캠퍼스로고',
};

function PrintSet({
  open,
  config,
  setConfig,
  paperTab,
  setTab,
  setPrintSetTrigger,
  loadedPaperData = undefined,
  isExchange = undefined,
}) {
  const [filter, setFilter] = useState(INSTITUTE.NAME);
  const [openedFilters, setOpenedFilters] = useState([]);
  const [toggleVocaFirstWordShow, setToggleVocaFirstWordShow] = useState(false);
  const [toggleExamKorShow, setToggleExamKorShow] = useState(false);
  const [logoMouseOver, setLogoMouseOver] = useState(false);
  const fileRef = useRef(null);

  // 저장한 시험지 로드시 config 세팅
  useEffect(() => {
    if (loadedPaperData === undefined) return;
    const restoredVocaFirstWordShow = loadedPaperData.voca_first_word_show ?? false;
    const restoredExamKorShow = loadedPaperData.exam_kor_show ?? false;
    setToggleVocaFirstWordShow(restoredVocaFirstWordShow);
    setToggleExamKorShow(restoredExamKorShow);
    setConfig(prev => {
      return {
        ...prev,
        orgName: loadedPaperData.academy_name,
        orgLogoUrl: loadedPaperData.logoUrl,
        className: loadedPaperData.class_name,
        teacherName: loadedPaperData.teacher_name,
        paperName: loadedPaperData.exam_name,
        viewMode: loadedPaperData.view_mode,
        fontSize: loadedPaperData.font_size ?? PAPER_CONFIG.FONT_SIZE.NORMAL,
        spacing: loadedPaperData.line_spacing ?? PAPER_CONFIG.LINE_SPACING.NORMAL,
        paperDiv: loadedPaperData.paper_div ?? 2,
      };
    });
    if (loadedPaperData.view_mode) {
      setTab(loadedPaperData.view_mode);
    }
  }, [loadedPaperData, setConfig, setTab]);

  const handleLogofile = async e => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file !== undefined) {
      try {
        const fd = new FormData();
        fd.append('image', file);
        const { data } = await vocabularyApi.saveLogo(fd);
        setConfig(prev => ({
          ...prev,
          orgLogoFile: file,
          orgLogoUrl: data.url,
        }));
      } catch (error) {
        console.error(error);
      } finally {
        e.target.value = null;
      }
    }
  };

  useEffect(() => {
    if (isExchange) {
      setToggleVocaFirstWordShow(false);
      setToggleExamKorShow(false);
    }
  }, [isExchange]);

  // 토글버튼 이벤트 config에 저장
  useEffect(() => {
    setConfig(prev => ({
      ...prev,
      vocaFirstWordShow: toggleVocaFirstWordShow,
      examKorShow: toggleExamKorShow,
    }));
  }, [toggleVocaFirstWordShow, toggleExamKorShow, setConfig]);

  return (
    <div
      className="absolute top-[0] right-[0] flex justify-between transition-all items-center h-full bg-[#969ba4]"
      style={{ right: open.set || open.print ? 0 : '-600px' }}
    >
      <div className="flex flex-col items-center justify-start h-full w-[440px]">
        <div className="grow overflow-auto w-full bg-[white] py-[30px] px-[24px]">
          <div className="text-[18px] font-[700] mb-[24px]">시험지 설정</div>
          <div className="text-[14px] font-[700] mb-[8px]">캠퍼스표기</div>
          <div className="mb-[12px]">
            <Select
              value={filter}
              fullWidth
              onChange={e => {
                if (e.target.value === INSTITUTE.LOGO) {
                  setConfig(prev => ({ ...prev, logoAppearYN: true }));
                } else {
                  setConfig(prev => ({ ...prev, logoAppearYN: false }));
                }
                setFilter(e.target.value);
                setPrintSetTrigger(prev => !prev);
              }}
              onOpen={() => setOpenedFilters([...openedFilters, '구분'])}
              onClose={() =>
                setOpenedFilters(openedFilters.filter(f => f !== '구분'))
              }
              displayEmpty
              size="small"
              IconComponent={() => (
                <img
                  src={ArrowIc}
                  alt="ArrowIc"
                  style={{
                    transform: openedFilters.includes('구분')
                      ? 'rotate(180deg)'
                      : 'rotate(0deg)',
                  }}
                />
              )}
              sx={{ background: '#fff' }}
            >
              <MenuItem
                value={INSTITUTE.NAME}
                sx={{ fontFamily: 'Pretendard' }}
              >
                캠퍼스명
              </MenuItem>
              <MenuItem
                value={INSTITUTE.LOGO}
                sx={{ fontFamily: 'Pretendard' }}
              >
                캠퍼스로고
              </MenuItem>
            </Select>
          </div>
          <div className="w-full">
            {filter === INSTITUTE.NAME ? (
              <div className="w-full mb-[12px]">
                <div className="mb-[8px]">캠퍼스명</div>
                <TextField
                  value={config.orgName}
                  onChange={e => {
                    if (e.target.value?.length > 12) return;
                    setConfig({
                      ...config,
                      orgName: e.target.value,
                    });
                  }}
                  fullWidth
                  size="small"
                  placeholder="캠퍼스명을 입력해 주세요(최대 12자)"
                  onBlur={() => setPrintSetTrigger(prev => !prev)}
                  InputProps={{
                    style: { fontFamily: 'Pretendard' },
                  }}
                />
              </div>
            ) : (
              <div className="w-full">
                <div className="mb-[12px]">캠퍼스로고</div>
                <div className="flex justify-between items-center gap-2 mb-[8px] overflow-hidden text-ellipsis">
                  <div className="grow flex justify-between h-[38px] items-center gap-2 overflow-hidden text-ellipsis border border-[#E2E8EF]">
                    <div
                      className="flex items-center justify-start px-[14px] leading-[17px] text-[#A9B6CA]"
                      style={{
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        wordBreak: 'break-word',
                      }}
                    >
                      {config?.orgLogoFile === null
                        ? '캠퍼스로고를 업로드 해 주세요'
                        : config?.orgLogoFile?.name}
                    </div>
                  </div>
                  <input
                    ref={fileRef}
                    onChange={handleLogofile}
                    type="file"
                    style={{ display: 'none' }}
                  />
                  <Button
                    variant="gray"
                    sx={{
                      flexShrink: 0,
                      px: '20px',
                      color: '#383C4B',
                      fontWeight: 700,
                    }}
                    onClick={() => fileRef.current.click()}
                  >
                    업로드
                  </Button>
                </div>
                <div
                  className="flex justify-center items-center text-[#383C4B] font-[700] w-full h-[130px] border mb-[12px] bg-[#fafafa]"
                  style={{
                    backgroundImage: `url(${config.orgLogoUrl})`,
                    backgroundSize: 'contain',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                  }}
                  onMouseEnter={
                    config?.orgLogoUrl !== null
                      ? () => setLogoMouseOver(true)
                      : null
                  }
                  onMouseLeave={
                    config?.orgLogoUrl !== null
                      ? () => setLogoMouseOver(false)
                      : null
                  }
                >
                  {config?.orgLogoUrl === null && '미리보기'}
                  {config?.orgLogoUrl !== null && logoMouseOver && (
                    <button
                      type="button"
                      className="w-[58px] h-[24px] text-[12px] rounded-[2px] flex justify-center items-center bg-[#E2E8EF]"
                      onClick={() => {
                        setConfig({
                          ...config,
                          orgLogoFile: null,
                          orgLogoUrl: null,
                        });
                      }}
                    >
                      삭제하기
                    </button>
                  )}
                </div>
              </div>
            )}
          </div>
          <div className="w-full mb-[12px]">
            <div className="mb-[8px]">클래스명</div>
            <TextField
              value={config.className}
              onChange={e => {
                if (e.target.value?.length > 8) return;
                setConfig({
                  ...config,
                  className: e.target.value,
                });
              }}
              fullWidth
              size="small"
              maxLength={10}
              placeholder="클래스명을 입력해 주세요(최대 8자)"
              onBlur={() => setPrintSetTrigger(prev => !prev)}
              InputProps={{
                style: { fontFamily: 'Pretendard' },
              }}
            />
          </div>
          <div className="w-full mb-[12px]">
            <div className="mb-[8px]">선생님(인쇄용)</div>
            <TextField
              value={config.teacherName}
              onChange={e => {
                if (e.target.value?.length > 7) return;
                setConfig({
                  ...config,
                  teacherName: e.target.value,
                });
              }}
              fullWidth
              size="small"
              placeholder="성함을 입력해주세요(최대7자)"
              onBlur={() => setPrintSetTrigger(prev => !prev)}
              InputProps={{
                style: { fontFamily: 'Pretendard' },
              }}
            />
          </div>
          <div className="w-full mb-[12px]">
            <div className="mb-[8px]">시험지명</div>
            <TextField
              value={config.paperName}
              onChange={e => {
                if (e.target.value?.length > 30) return;
                setConfig({
                  ...config,
                  paperName: e.target.value,
                });
              }}
              fullWidth
              size="small"
              placeholder="시험지명을 입력해주세요(최대30자)"
              onBlur={() => setPrintSetTrigger(prev => !prev)}
              InputProps={{
                style: { fontFamily: 'Pretendard' },
              }}
            />
          </div>
          <hr className="my-[12px] border border-[#A9B6CA]" />
          <div className="flex justify-between items-center h-[36px]">
            <div className="text-[14px] font-[700]">영단어 첫글자 보여주기</div>
            <ToggleSwitch
              toggle={toggleVocaFirstWordShow}
              setToggle={setToggleVocaFirstWordShow}
            />
          </div>
          <hr className="my-[12px] border border-[#A9B6CA]" />
          <div className="flex justify-between items-center h-[36px]">
            <div className="text-[14px] font-[700]">예문 해석 보여주기</div>
            <ToggleSwitch
              toggle={toggleExamKorShow}
              setToggle={setToggleExamKorShow}
            />
          </div>
          <hr className="my-[12px] border border-[#A9B6CA]" />
          <div className="text-[14px] font-[700] mb-[8px]">단설정</div>
          <FormControl>
            <RadioGroup
              row
              value={config.paperDiv}
              onChange={e =>
                setConfig({ ...config, paperDiv: Number(e.target.value) })
              }
            >
              <FormControlLabel
                value={2}
                control={<Radio sx={radioStyle} />}
                label="2단"
              />
              <FormControlLabel
                value={1}
                control={<Radio sx={radioStyle} />}
                label="1단"
              />
            </RadioGroup>
          </FormControl>
          <hr className="my-[12px] border border-[#A9B6CA]" />
          <div className="text-[14px] font-[700] mb-[8px]">글자크기</div>
          <FormControl>
            <RadioGroup
              row
              value={config.fontSize}
              onChange={e =>
                setConfig({ ...config, fontSize: Number(e.target.value) })
              }
            >
              <FormControlLabel
                value={PAPER_CONFIG.FONT_SIZE.NORMAL}
                control={<Radio sx={radioStyle} />}
                label="보통"
              />
              <FormControlLabel
                value={PAPER_CONFIG.FONT_SIZE.SMALL}
                control={<Radio sx={radioStyle} />}
                label="최소"
              />
              <FormControlLabel
                value={PAPER_CONFIG.FONT_SIZE.LARGE}
                control={<Radio sx={radioStyle} />}
                label="최대"
              />
            </RadioGroup>
          </FormControl>
          <hr className="my-[12px] border border-[#A9B6CA]" />
          <div className="text-[14px] font-[700] mb-[8px]">줄간격</div>
          <FormControl>
            <RadioGroup
              row
              value={config.spacing}
              onChange={e =>
                setConfig({ ...config, spacing: Number(e.target.value) })
              }
            >
              <FormControlLabel
                value={PAPER_CONFIG.LINE_SPACING.NORMAL}
                control={<Radio sx={radioStyle} />}
                label="보통"
              />
              <FormControlLabel
                value={PAPER_CONFIG.LINE_SPACING.SMALL}
                control={<Radio sx={radioStyle} />}
                label="좁게"
              />
              <FormControlLabel
                value={PAPER_CONFIG.LINE_SPACING.LARGE}
                control={<Radio sx={radioStyle} />}
                label="넓게"
              />
            </RadioGroup>
          </FormControl>
          <hr className="my-[12px] border border-[#A9B6CA]" />
          <div className="text-[14px] font-[700] mb-[8px]">보기 설정</div>
          <FormControl>
            <RadioGroup
              defaultValue={PAPER_TABS.TEST_PAPER}
              value={paperTab}
              onChange={e => {
                setTab(e.target.value);
                setConfig({ ...config, viewMode: e.target.value });
              }}
            >
              <FormControlLabel
                value={PAPER_TABS.TEST_PAPER}
                control={<Radio sx={radioStyle} />}
                label="시험지 보기"
              />
              <FormControlLabel
                value={PAPER_TABS.ANSWER}
                control={<Radio sx={radioStyle} />}
                label="정답만 보기"
              />
              <FormControlLabel
                value={PAPER_TABS.ANSWER_TEST_PAPER}
                control={<Radio sx={radioStyle} />}
                label="정답이 표시된 시험지 보기"
              />
              <FormControlLabel
                value={PAPER_TABS.VOCABULARY_LIST}
                control={<Radio sx={radioStyle} />}
                label="어휘 리스트 보기"
              />
            </RadioGroup>
          </FormControl>
        </div>
      </div>
    </div>
  );
}

PrintSet.propTypes = {
  open: PropTypes.object.isRequired,
  config: PropTypes.object.isRequired,
  setConfig: PropTypes.func.isRequired,
  paperTab: PropTypes.string.isRequired,
  setTab: PropTypes.func.isRequired,
  generatedPaper: PropTypes.array,
  setPrintSetTrigger: PropTypes.func.isRequired,
  loadedPaperData: PropTypes.object,
  isExchange: PropTypes.bool,
};

export default React.memo(PrintSet);

